import { UrlMatchResult, UrlSegment } from '@angular/router';

/**
 * Matchers de ruta del flujo de compra (v2), que está montado en la RAÍZ antes del
 * `HomeModule` original.
 *
 * Viven en un archivo sin componentes a propósito: `app.routes.ts` importa
 * `conAlgunSegmento` para la ruta perezosa del flujo, y si estuviera en
 * `home-v2.routes.ts` arrastraría todos los pasos al bundle inicial.
 */

/**
 * Coincide como `path: ''` (no consume nada) pero SOLO si queda al menos un segmento
 * por resolver.
 *
 * Con `path: ''` a secas, la URL `/` la tomaría el flujo de compra: Angular da por
 * coincidente una ruta de path vacío aunque ningún hijo coincida con lo que sobra
 * —que es nada— y NO retrocede a la ruta hermana. La cartelera del flujo original no
 * se alcanzaría nunca. Exigiendo un segmento, `/` no coincide acá y el router sigue
 * con la ruta siguiente.
 */
export function conAlgunSegmento(segments: UrlSegment[]): UrlMatchResult | null {
  return segments.length > 0 ? { consumed: [] } : null;
}

/**
 * Segmentos de un solo pedazo que NO son el slug de un evento.
 *
 * El comodín `:slug` del flujo atraparía cualquier URL de un segmento: la página de
 * «evento no encontrado» se convertiría en el evento «event-not-found», y `/step1`
 * (la ruta de rescate sin slug) en el evento «step1». Con el matcher, esos segmentos
 * no coinciden y el router sigue: a la ruta de rescate, o al flujo original para lo
 * que el v2 no reemplaza (`venue/:slug`, `p/:token`, `event-not-found`).
 */
const NO_SON_SLUG = new Set(['event-not-found', 'thank-you', 'step1', 'prueba', 'mis-boletos', 'venue', 'p']);

/** `/:slug` exacto (un segmento) cuando ese segmento puede ser un evento. */
export function slugDeEvento(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length !== 1 || NO_SON_SLUG.has(segments[0].path)) return null;
  return { consumed: segments, posParams: { slug: segments[0] } };
}
